<section [class.row-hyperlink]="redirectUrl">
    <gen-dynamic-form-table
        class=""
        [data]="data"
        [formId]="config.formId"
        [formVertical]="config.formVertical || false"
        [tableVertical]="config.tableVertical || false"
        [viewAsTable]="config.viewAsTable || true"
        [editMode]="false"
        [disabled] = "config.disabled"
        [showAddButton]="false"
        [showDeleteButton]="false"
        [emptyMessageDisplay]="config.emptyMessageDisplay"
        [customizeRowClassConfig]="config.customizeRowClassConfig"
        [availableCustomClassBasedOn]="config.availableCustomClassBasedOn"
        [hideTitles]="config.hideTitles"
        (itemClickEmitter)="onTestRowClick($event)"
    ></gen-dynamic-form-table>
</section>